/* eslint-disable no-process-env, no-magic-numbers */

import env from './env';

export default {
  env: env,
  host: process.env.HOST || 'http://0.0.0.0',
  port: process.env.PORT || 3030,

  server: {
    baseUrl: process.env.BACKEND_URL || 'https://api.safeexcavator.com/api',
    imageUrlDomain: process.env.IMAGE_URL_DOMAIN,
  },


  googleAnalytics: {
    trackId: process.env.GOOGLE_ANALYTICS_ID || null,
  },

  rollbar: {
    accessToken: process.env.ROLLBAR_TOKEN || null,
    captureUncaught: true,
    payload: {
      environment: env
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/main.js